import React from "react";

import ApiHelper from "../lib/UniversalTable/CoreHelpers/ApiHelper";
import FilterOptionsHelper from "../lib/UniversalTable/CoreHelpers/FilterOptionsHelper";
import normalizeFilterValues from "../lib/UniversalTable/CoreHelpers/normalizeFilterValues";

export default class SingleValueFilterAbstract extends React.Component {
  normalizeSelectedValues(selectedValues) {
    const { column } = this.props;

    if (ApiHelper.getColumnAttributeForFiltering(column) !== "market") {
      return selectedValues;
    }

    return selectedValues.map(value =>
      typeof value === "string" ? value.toUpperCase() : value
    );
  }

  handleChange(value) {
    const { onChange, column } = this.props;

    const selectedValues = this.normalizeSelectedValues(
      value.map(option => option.value)
    );
    onChange(
      column.filter_type === "ruleset"
        ? selectedValues.slice(0, 1)
        : selectedValues
    );
  }

  getSelectedOptions(options, value, isRuleset) {
    const selectedValues = normalizeFilterValues(value);

    return options.filter(option =>
      selectedValues.some(selected =>
        isRuleset
          ? selected === option.value
          : String(selected).toLowerCase() === String(option.value).toLowerCase()
      )
    );
  }

  mapOptionsList(options, settings) {
    const { translate, column } = this.props;
    const { labelPrefix, isRuleset } = settings;

    const optionKeys = FilterOptionsHelper.getFilterOptionKeys({
      filter_data: options
    });

    return optionKeys.map(optionValue => ({
      label: translate(
        labelPrefix
          ? `${labelPrefix}${optionValue}`
          : isRuleset
            ? optionValue
            : FilterOptionsHelper.getOptionTranslationKey(column, optionValue)
      ),
      value: optionValue
    }));
  }
}
